/**
 * @file 获取列表数据
 * @author lizhaoxia(lizhaoxia@baijiahulian.com)
 * @date 2019-07-08
 */

import http from './http';
import constant from './constant';

// eslint-disable-next-line import/prefer-default-export
export const fetchUserInfo = params => http.get(constant.USER.GET_USER_INFO, {params});
